import { Colors } from '../../theme'

export default {
  padding: '5px 20px',
  marginBottom: 25,
  ['@media print']: { // eslint-disable-line no-useless-computed-key
    float: 'left !important',
    width: '100%',
    margin: 0,
    border: `1px solid ${Colors.Palette.borderColor} !important`,
    display: 'inline-block !important',
    '& .row div:nth-child(1)': {
      float: 'left !important'
    }
  }
}



// WEBPACK FOOTER //
// ./src/styles/cards/summary.js